import { createContext, useCallback, useContext, useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;
const Ctx = createContext({ gamer: null, host: null, loading: true, refresh: () => {}, logoutGamer: () => {}, logoutHost: () => {} });

export function MafiaAuthProvider({ children }) {
  const [gamer, setGamer] = useState(null);
  const [host, setHost] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    // If returning from OAuth, AuthCallback will exchange first — skip
    if (typeof window !== 'undefined' && window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const [g, h] = await Promise.all([
        fetch(`${API}/api/mafia/auth/me`, { credentials: 'include' }).then((r) => r.ok ? r.json() : null).catch(() => null),
        fetch(`${API}/api/mafia/auth/host/me`, { credentials: 'include' }).then((r) => r.ok ? r.json() : null).catch(() => null),
      ]);
      setGamer(g);
      setHost(h);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const logoutGamer = async () => {
    await fetch(`${API}/api/mafia/auth/logout`, { method: 'POST', credentials: 'include' });
    setGamer(null);
  };
  const logoutHost = async () => {
    await fetch(`${API}/api/mafia/auth/host/logout`, { method: 'POST', credentials: 'include' });
    setHost(null);
  };

  return (
    <Ctx.Provider value={{ gamer, host, loading, refresh, logoutGamer, logoutHost, setGamer, setHost }}>
      {children}
    </Ctx.Provider>
  );
}

export const useMafiaAuth = () => useContext(Ctx);
